const dataSobreMi = {
  nombre: "Samanta",
  saludo: ["Hola!", "Soy"],
  descripcion: [
    "Después de muchos años en el área de ventas, me aventuro al mundo de la programación mezclando todos mis dones para este hermoso camino como Desarrolladora Web Full Stack.",
    "Soy de Mendoza, Argentina. Me gusta caminar entre la montaña, explorar nuevos lugares y disfrutar la buena compañia.",
  ],
};

export default dataSobreMi;
